export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "container_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
          "pallets_tab_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets"])},
          "edit_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "new_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir pallet"])},
          "destroy_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar pallet ", _interpolate(_named("pg_code"))])},
          "destroy_confirm_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Estás seguro de que deseas eliminar este pallet?"])},
          "destroy_confirm_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}